import { useState } from 'react'
import useRequestPending from 'shared/hooks/useRequestPending'
import { createVehicle } from 'dashboard-vehicles/actions'
import { CURRENT_COUNTRY_CANADA } from 'shared/constants'
import useCountryState from 'shared/hooks/useCountryState'
import featureToggles from 'shared/featureToggles'
import { createVehiclePendingSelector } from 'dashboard-vehicles/selectors'
import { businessAccountSelector } from 'auth/selectors'

import VehicleFormComponent from '@components/VehicleForm'
import InfoModal from '@components/InfoModal'

const VehicleForm = ({ createVehicle, pending, translate: t, onSuccess, isBusinessAccount }) => {
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)
    const [isRentalCarModalOpen, setIsRentalCarModalOpen] = useState(false)

    const { countryStateComponent, selectedCountry, selectedState, setSelectedCountry, setSelectedState } =
        useCountryState()
    const { error, isLoading } = useRequestPending(pending, () => {
        setIsInfoModalOpen(true)
    })
    const formRef = React.useRef(null)

    const submitVehicle = async formModel => {
        const { tag, make, model, color, isRentalCar, rentalExpiryDate } = formModel
        createVehicle(tag, make, model, color, selectedCountry, selectedState, isRentalCar, rentalExpiryDate, onSuccess)
        setSelectedCountry(CURRENT_COUNTRY_CANADA)
        setSelectedState(null)
        formRef?.current?.resetModel()
    }

    return (
        <>
            {isInfoModalOpen && isBusinessAccount && (
                <InfoModal
                    title="dashboard.vehicles.warning.title"
                    text="dashboard.vehicles.warning.text"
                    onDismiss={() => {
                        if (onSuccess) {
                            onSuccess()
                        }
                        setIsInfoModalOpen(false)
                    }}
                />
            )}
            {isRentalCarModalOpen && (
                <InfoModal
                    title="dashboard.vehicles.rental.car.modal.title"
                    text={`${t('dashboard.vehicles.rental.car.modal.text')}`}
                    buttonText="info.popup.button.ok"
                    onDismiss={() => {
                        setIsRentalCarModalOpen(false)
                    }}
                />
            )}
            <VehicleFormComponent
                submitVehicle={submitVehicle}
                isLoading={isLoading}
                error={error}
                countryStateComponent={countryStateComponent}
                isSubmitButtonDisplayed
                formRef={formRef}
                onIsRentalCarChecked={() => {
                    setIsRentalCarModalOpen(true)
                }}
                hasRentalCarFlow={featureToggles.hasRentalCarFlow}
            />
        </>
    )
}

const mapDispatchToProps = {
    createVehicle,
}

const mapStateToProps = createStructuredSelector({
    pending: createVehiclePendingSelector,
    isBusinessAccount: businessAccountSelector,
})

export default compose(withTranslate, connect(mapStateToProps, mapDispatchToProps))(VehicleForm)
